module.exports = __webpack_public_path__ + "static/media/piano.e5a3c7b1.jpg";